AFRAME.registerComponent('main-elements-moving', {
    schema: {
        currentStep: { type: 'int', default: 0 },
    },

    init: function () {
        this.lastClickTime = 0
        this.rightArrowModel = document.querySelector('#right-triangle-arrow-model')
        this.leftArrowModel = document.querySelector('#left-triangle-arrow-model')
        this.animanitionSegmentTime = 600

        // this.createButtons();

        if (this.rightArrowModel && this.leftArrowModel) {
            this.rightArrowModel.addEventListener('click', () => this.handleClickOnArrow(true))
            this.leftArrowModel.addEventListener('click', () => this.handleClickOnArrow(false))

            this.rightArrowModel.addEventListener('mouseenter', () => {
                if (this.checkIfChartNotBlocked()) return
                this.changeScale(this.rightArrowModel, 0.25, 200)
            })
            this.rightArrowModel.addEventListener('mouseleave', () => this.changeScale(this.rightArrowModel, 0.2, 200))

            this.leftArrowModel.addEventListener('mouseenter', () => {
                if (this.checkIfChartNotBlocked()) return
                this.changeScale(this.leftArrowModel, 0.25, 200)
            })
            this.leftArrowModel.addEventListener('mouseleave', () => this.changeScale(this.leftArrowModel, 0.2, 200))
        }
    },

    createButtons: function () {
        const buttons = [
            { id: "next-step", position: "0 0.1 0", image: "./vr-assets/rotation-icons-2/up.png" },
            { id: "prev-step", position: "0 -0.1 0", image: "./vr-assets/rotation-icons-2/down.png" }
        ]

        buttons.forEach((item, index) => {
            const btn = document.createElement("a-entity");
            btn.setAttribute("id", item.id);

            btn.setAttribute("ui-button", {
                label: "",
                image: item.image || '',
                width: 0.24,
                height: 0.16,
                depth: 0.02,
                type: "rounded-box",
                radius: 0.015,
                preferredFontSize: 0.04,
                textZp: 0.015,
            });
            btn.setAttribute("position", item.position);

            this.el.appendChild(btn);

            btn.addEventListener("click", () => {
                this.handleClickOnArrow(item.id === "next-step");
            })
        })
    },

    handleClickOnArrow: function (increasing) {
        if (this.checkIfChartNotBlocked()) return

        const now = Date.now();
        if (now - this.lastClickTime < this.animanitionSegmentTime) return
        this.lastClickTime = now;

        this.isStepIncreased = increasing
        this.data.currentStep += increasing ? 1 : -1

        if (this.data.currentStep < 0) this.data.currentStep = 2
        if (this.data.currentStep > 2) this.data.currentStep = 0

        if (window.VRPanelsSlidingManager) {
            if (this.data.currentStep === 0) {
                setTimeout(() => {
                    if (window.VRPanelsSlidingManager && this.data.currentStep === 0) {
                        window.VRPanelsSlidingManager.resumePanels();
                    }
                }, this.animanitionSegmentTime || 600);
            } else {
                window.VRPanelsSlidingManager.suspendPanels();
            }
        }
        this.updateElementsPosition()

        if (window.gtag) gtag('event', increasing ? 'VR_RightArrowClick' : 'VR_LeftArrowClick');
    },

    trackPanelsPosition: function () {
        const centralPanel = this.getCentralPanel();
        const leftPanel = document.querySelector('#left-panel-2');
        const rightPanel = document.querySelector('#right-container');

        if (!centralPanel || !leftPanel || !rightPanel) {
            console.warn('movement: Some panels not found');
            return;
        }

        const { x: pRX, y: pRY, z: pRZ } = rightPanel.object3D.position;
        const { x: pLX, y: pLY, z: pLZ } = leftPanel.object3D.position;
        const { x: pCX, y: pCY, z: pCZ } = centralPanel.object3D.position;

        const fixedCenterX = 0;
        const fixedCenterY = 2.2;
        const fixedCenterZ = -1.2;

        const defaultCenterX = 0;
        const defaultCenterY = 1.6;
        const defaultCenterZ = -1.2;

        const tolerance = 0.5;

        const rightDistanceFromCenter = Math.sqrt(
            Math.pow(pRX - fixedCenterX, 2) +
            Math.pow(pRY - fixedCenterY, 2) +
            Math.pow(pRZ - fixedCenterZ, 2)
        );

        const leftDistanceFromCenter = Math.sqrt(
            Math.pow(pLX - fixedCenterX, 2) +
            Math.pow(pLY - fixedCenterY, 2) +
            Math.pow(pLZ - fixedCenterZ, 2)
        );

        const centralDistanceFromDefault = Math.sqrt(
            Math.pow(pCX - defaultCenterX, 2) +
            Math.pow(pCY - defaultCenterY, 2) +
            Math.pow(pCZ - defaultCenterZ, 2)
        );

        let panelInCenter = 'UNKNOWN';
        if (rightDistanceFromCenter < tolerance) {
            panelInCenter = 'RIGHT';
        } else if (leftDistanceFromCenter < tolerance) {
            panelInCenter = 'LEFT';
        } else if (centralDistanceFromDefault < tolerance) {
            panelInCenter = 'CENTER';
        }

        const originalRightX = 0.79;
        const originalRightY = 2.2;
        const originalRightZ = -2.49;

        const rightDistanceFromOriginal = Math.sqrt(
            Math.pow(pRX - originalRightX, 2) +
            Math.pow(pRY - originalRightY, 2) +
            Math.pow(pRZ - originalRightZ, 2)
        );

        const originalLeftX = -0.8;
        const originalLeftY = 2.2;
        const originalLeftZ = -2.5;

        const leftDistanceFromOriginal = Math.sqrt(
            Math.pow(pLX - originalLeftX, 2) +
            Math.pow(pLY - originalLeftY, 2) +
            Math.pow(pLZ - originalLeftZ, 2)
        );

        let rightPanelPosition = 'UNKNOWN';
        if (rightDistanceFromCenter < tolerance) {
            rightPanelPosition = 'CENTER';
        } else if (rightDistanceFromOriginal < tolerance) {
            rightPanelPosition = 'RIGHT (original)';
        } else {
            const distanceFromLeft = Math.sqrt(
                Math.pow(pRX - originalLeftX, 2) +
                Math.pow(pRY - originalLeftY, 2) +
                Math.pow(pRZ - originalLeftZ, 2)
            );
            if (distanceFromLeft < tolerance) {
                rightPanelPosition = 'LEFT';
            }
        }

        let leftPanelPosition = 'UNKNOWN';
        if (leftDistanceFromCenter < tolerance) {
            leftPanelPosition = 'CENTER';
        } else if (leftDistanceFromOriginal < tolerance) {
            leftPanelPosition = 'LEFT (original)';
        } else {
            const distanceFromRight = Math.sqrt(
                Math.pow(pLX - originalRightX, 2) +
                Math.pow(pLY - originalRightY, 2) +
                Math.pow(pLZ - originalRightZ, 2)
            );
            if (distanceFromRight < tolerance) {
                leftPanelPosition = 'RIGHT';
            }
        }

        console.log('movement: Step:', this.data.currentStep, '| isStepIncreased:', this.isStepIncreased, '| Center:', panelInCenter, '| Right:', rightPanelPosition, '| Left:', leftPanelPosition);
    },

    getCentralPanel: function () {
        const searchPanel = document.querySelector('#search-center-panel');
        if (searchPanel && searchPanel.object3D && searchPanel.object3D.visible) {
            return searchPanel;
        }
        
        const watchlistTable = document.querySelector('#watchlist-table');
        if (watchlistTable && watchlistTable.object3D && watchlistTable.object3D.visible) {
            return watchlistTable;
        }

        return document.querySelector('#large-center-panel');
    },

    updateElementsPosition: function () {
        const self = this;

        console.log('updateElementsPosition', this.currentStep)
        const centralPanel = this.getCentralPanel()
        const leftPanel = document.querySelector('#left-panel-2')
        const rightPanel = document.querySelector('#right-container')
        const dockPanel = document.querySelector('#dock')


        const { x: pRX, y: pRY, z: pRZ } = rightPanel.object3D.position;
        const { x: pLX, y: pLY, z: pLZ } = leftPanel.object3D.position;
        const { x: pCX, y: pCY, z: pCZ } = centralPanel.object3D.position;

        const { x: rLX, y: rLY, z: rLZ } = leftPanel.getAttribute('rotation');
        const { x: rRX, y: rRY, z: rRZ } = rightPanel.getAttribute('rotation');

        const getTargetRotation = (el, targetX) => {
            const distCenter = Math.abs(targetX - 0);
            const distLeft = Math.abs(targetX - (-0.8));
            const distRight = Math.abs(targetX - 0.79);

            if (distCenter < distLeft && distCenter < distRight) {
                return (el.id === 'large-center-panel') ? '0 -45 0' : '0 0 0';
            }
            
            if (el.id === 'large-center-panel') {
                const _chartTypeElLocal = document.querySelector('[chart-type-control]');
                const _isMmapLocal = _chartTypeElLocal?.getAttribute('chart-type-control')?.selectedPrimeAction === 'mmap';
                const _mmapModeLocal = _isMmapLocal ? ((window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode) ? window.MarketMapModeSwitching.getCurrentMode() : '2d') : null;
                const _isMmap2D = _isMmapLocal && _mmapModeLocal === '2d';

                if (!_isMmap2D) {
                    return targetX < 0 ? '0 0 0' : '0 -90 0';
                }
            }

            return targetX < 0 ? '0 45 0' : '0 -45 0';
        };

        const getPanelTargetY = (panelId, destX) => {
            const isCenterSlot = Math.abs(destX) < 0.4;
            if (panelId === 'watchlist-table') {
                return isCenterSlot ? 2.57 : 2.65;
            }
            if (panelId === 'search-center-panel') return 2.2;
            if (panelId === 'large-center-panel') return 1.6;
            return 2.2; 
        };

        const destX_central = this.isStepIncreased ? pRX : pLX;
        const destZ_central = this.isStepIncreased ? pRZ : pLZ;

        const centralPanels = [
            document.getElementById('large-center-panel'),
            document.getElementById('watchlist-table'),
            document.getElementById('search-center-panel')
        ].filter(p => p !== null);

        // Capture target rotation for large-center-panel (needed for mmap wrapper compensation)
        let _largePanelTargetRotY = -45; // fallback
        centralPanels.forEach(p => {
            const targetY = getPanelTargetY(p.id, destX_central);
            const newPosition = `${destX_central} ${targetY} ${destZ_central}`;
            const targetRotation = getTargetRotation(p, destX_central);
            
            if (p.id === 'large-center-panel') {
                _largePanelTargetRotY = parseFloat(targetRotation.split(' ')[1]) || 0;
            }

            animatePosition(p, 0, newPosition);
            animateRotation(p, 0, targetRotation);
            
            p.setAttribute('expected-panel-rotation', targetRotation);
            p.emit('start_position_0');
            p.emit('start_rotation_0');

            if (p.id === 'large-center-panel') {
                const _chartTypeElLocal = document.querySelector('[chart-type-control]');
                const _actionLocal = _chartTypeElLocal?.getAttribute('chart-type-control')?.selectedPrimeAction;
                const _isMmapLocal = _actionLocal === 'mmap';
                const _isNewsGraphLocal = _actionLocal === 'news-graph';
                const _mmapModeLocal = _isMmapLocal ? ((window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode) ? window.MarketMapModeSwitching.getCurrentMode() : '2d') : null;
                const _isMmap2D = _isMmapLocal && _mmapModeLocal === '2d';

                const rotY = parseFloat(targetRotation.split(' ')[1]) || 0;
                const isCenterDest = self.data.currentStep === 0;
                
                let bannerRotY = -rotY;
                
                if (_isMmap2D) {
                    bannerRotY = isCenterDest ? -rotY : 0;
                }
                
                const counterRot = `0 ${bannerRotY} 0`;
                
                const BANNER_Y_ORIGINAL = 0.46; 
                const BANNER_Y_MMAP_CENTER = 0.58;
                const BANNER_Y_MMAP_SIDE = 0.65;
                const TIMEDATE_Y_ORIGINAL = 0.43;
                const TIMEDATE_Y_MMAP_CENTER = 0.55;
                const TIMEDATE_Y_MMAP_SIDE = 0.62;

                const stockBanner = p.querySelector('#stock-banner');
                if (stockBanner) {
                    if (_isMmapLocal) {
                        const bannerY = isCenterDest ? BANNER_Y_MMAP_CENTER : BANNER_Y_MMAP_SIDE;
                        animatePosition(stockBanner, 0, `0 ${bannerY} 0`);
                        stockBanner.emit('start_position_0');
                    } else if (_isNewsGraphLocal) {
                        const bannerY = isCenterDest ? 0.58 : 0.65;
                        animatePosition(stockBanner, 0, `0 ${bannerY} 0`);
                        stockBanner.emit('start_position_0');
                    } else {
                        animatePosition(stockBanner, 0, `0 ${BANNER_Y_ORIGINAL} 0`);
                        stockBanner.emit('start_position_0');
                    }
                }
                
                const currentTimeAndDate = p.querySelector('#current-time-date');
                if (currentTimeAndDate) {
                    if (_isMmapLocal) {
                        const dateY = isCenterDest ? TIMEDATE_Y_MMAP_CENTER : TIMEDATE_Y_MMAP_SIDE;
                        animatePosition(currentTimeAndDate, 0, `0 ${dateY} 0`);
                        currentTimeAndDate.emit('start_position_0');
                    } else if (_isNewsGraphLocal) {
                        const dateY = isCenterDest ? 0.55 : 0.62;
                        animatePosition(currentTimeAndDate, 0, `0 ${dateY} 0`);
                        currentTimeAndDate.emit('start_position_0');
                    } else {
                        animatePosition(currentTimeAndDate, 0, `0 ${TIMEDATE_Y_ORIGINAL} 0`);
                        currentTimeAndDate.emit('start_position_0');
                    }
                }

                const moveArea = p.querySelector('#move-central-panel-area');
                if (moveArea && moveArea.getAttribute('visible')) {
                    animateRotation(moveArea, 0, counterRot);
                    moveArea.emit('start_rotation_0');

                    if (_isMmap2D) {
                        const MMAP_Y_CENTER_HANDLE = 0.11, MMAP_Y_SIDE_HANDLE = 0.30;
                        const _goingRightHandle = destX_central > pCX;
                        const _handleX = isCenterDest ? 0 : (_goingRightHandle ? 0.08 : 0.04);
                        const _handleZ = isCenterDest ? 0 : (_goingRightHandle ? 0 : 0.04);
                        const _handleBaseY = isCenterDest ? MMAP_Y_CENTER_HANDLE : MMAP_Y_SIDE_HANDLE;
                        animatePosition(moveArea, 0, `${_handleX} ${_handleBaseY + 0.48} ${_handleZ + 0.10}`);
                        moveArea.emit('start_position_0');
                    }
                }
            }
        });

        const destX_right = this.isStepIncreased ? pLX : pCX;
        const rightY = getPanelTargetY(rightPanel.id, destX_right);
        const newPositionRightPanel = `${destX_right} ${rightY} ${this.isStepIncreased ? pLZ : pCZ}`;
        const targetRotationRight = getTargetRotation(rightPanel, destX_right);
            
        animatePosition(rightPanel, 0, newPositionRightPanel)
        animateRotation(rightPanel, 0, targetRotationRight)
        rightPanel.emit('start_position_0')
        rightPanel.emit('start_rotation_0')

        const destX_left = this.isStepIncreased ? pCX : pRX;
        const leftY = getPanelTargetY(leftPanel.id, destX_left);
        const newPositionLeftPanel = `${destX_left} ${leftY} ${this.isStepIncreased ? pCZ : pRZ}`;
        const targetRotationLeft = getTargetRotation(leftPanel, destX_left);
            
        animatePosition(leftPanel, 0, newPositionLeftPanel)
        animateRotation(leftPanel, 0, targetRotationLeft)
        leftPanel.emit('start_position_0')
        leftPanel.emit('start_rotation_0')

        const _chartTypeEl = document.querySelector('[chart-type-control]');
        const _isMmapActive = _chartTypeEl?.getAttribute('chart-type-control')?.selectedPrimeAction === 'mmap';
        if (_isMmapActive) {
            const _mmapMode = (window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode)
                ? window.MarketMapModeSwitching.getCurrentMode()
                : (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
            if (_mmapMode === '2d' || _mmapMode === '3d') {
                const _mmapWrapper = document.querySelector('#stock-3d-cube-wrapper');
                if (_mmapWrapper) {
                    const isCenterDest = self.data.currentStep === 0;

                    if (_mmapMode === '2d') {
                        const _wrapperY = isCenterDest ? -_largePanelTargetRotY : 0;
                        animateRotation(_mmapWrapper, 0, `90 ${_wrapperY} 0`);
                        _mmapWrapper.emit('start_rotation_0');
                    }

                    const MMAP_Y_CENTER = 0.11;
                    const MMAP_Y_SIDE   = 0.30;
                    const _baseX = 0, _baseZ = 0;
                    const _goingRight = destX_central > pCX;
                    let _targetX = _baseX, _targetZ = _baseZ;
                    if (!isCenterDest) {
                        if (_goingRight) {
                            _targetX = _baseX + 0.08;
                        } else {
                            _targetX = _baseX + 0.04;
                            _targetZ = _baseZ + 0.04;
                        }
                    }
                    const _targetY = isCenterDest
                        ? (_mmapMode === '3d' ? 0 : MMAP_Y_CENTER)
                        : MMAP_Y_SIDE;
                    animatePosition(_mmapWrapper, '__mmap', `${_targetX} ${_targetY} ${_targetZ}`);
                    _mmapWrapper.emit('start_position___mmap');

                    if (_mmapMode === '2d') {
                        const _scaleVal = isCenterDest ? '0.9 0.9 0.9' : '0.75 0.65 0.75';
                        _mmapWrapper.setAttribute('animation__scale', {
                            property: 'scale',
                            to: _scaleVal,
                            dur: self.animanitionSegmentTime,
                            easing: 'easeInOutQuad',
                        });
                    } else {
                        const _scaleVal3d = isCenterDest ? '0.85 0.85 0.85' : '0.75 0.75 0.75';
                        _mmapWrapper.setAttribute('animation__scale', {
                            property: 'scale',
                            to: _scaleVal3d,
                            dur: self.animanitionSegmentTime,
                            easing: 'easeInOutQuad',
                        });
                    }

                    const _stockCubeEl = document.getElementById('stock-3d-cube');
                    const _vi = _stockCubeEl?.components?.['stock-cube-visualizer'];
                    let _lastColSectors = null;
                    if (_vi && _vi.sectorPlatforms && _vi.sectorPlatforms.size > 0) {
                        const _sortedByX = [..._vi.sectorPlatforms.entries()].sort((a, b) => b[1].x - a[1].x);
                        _lastColSectors = new Set(_sortedByX.slice(0, 5).map(([name]) => String(name)));

                        _vi.sectorPlatforms.forEach((sp, name) => {
                            if (_lastColSectors.has(String(name))) {
                                sp.bg.setAttribute('visible',    isCenterDest);
                                sp.label.setAttribute('visible', isCenterDest);
                            }
                        });

                        if (_vi.stockBars) {
                            _vi.stockBars.forEach(barInfo => {
                                const _s = barInfo.stock && String(barInfo.stock.sector);
                                if (_lastColSectors.has(_s)) {
                                    barInfo.bar?.setAttribute('visible', isCenterDest);
                                    barInfo.primaryLabel?.setAttribute('visible', isCenterDest);
                                    barInfo.companyIcon?.setAttribute('visible', isCenterDest);
                                }
                            });
                        }
                    }
                }
            }
        }

        const _reapplyHiddenSectors = () => {
            if (!_isMmapActive) return;
            const _mmapModeNow = (window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode)
                ? window.MarketMapModeSwitching.getCurrentMode()
                : (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
            if (_mmapModeNow !== '2d' && _mmapModeNow !== '3d') return;
            const isCenterNow = self.data.currentStep === 0;
            if (isCenterNow) return;

            const _stockCubeEl = document.getElementById('stock-3d-cube');
            const _vi = _stockCubeEl?.components?.['stock-cube-visualizer'];
            if (_vi && _vi.sectorPlatforms && _vi.sectorPlatforms.size > 0) {
                const _sortedByX = [..._vi.sectorPlatforms.entries()].sort((a, b) => b[1].x - a[1].x);
                const _hiddenSectors = new Set(_sortedByX.slice(0, 5).map(([name]) => String(name)));
                if (_vi.stockBars) {
                    _vi.stockBars.forEach(barInfo => {
                        const _s = barInfo.stock && String(barInfo.stock.sector);
                        if (_hiddenSectors.has(_s)) {
                            barInfo.primaryLabel?.setAttribute('visible', false);
                            barInfo.companyIcon?.setAttribute('visible', false);
                        }
                    });
                }
            }
        };

        const billboardInterval = setInterval(() => {
            const cameraRig = document.getElementById('cameraRig')
            if (cameraRig) {
                if (window.AppState && window.AppState.isTrueVRMode) {
                    cameraRig.emit('update-billboards')
                } else {
                    cameraRig.emit('refresh-billboards')
                }
            }
            this.el.sceneEl.emit('update-rotation', { x: 0, y: 0, z: 0 })
            _reapplyHiddenSectors();
        }, 50)

        setTimeout(() => {
            clearInterval(billboardInterval)
            const cameraRig = document.getElementById('cameraRig')
            if (cameraRig) {
                if (window.AppState && window.AppState.isTrueVRMode) {
                    cameraRig.emit('update-billboards')
                } else {
                    cameraRig.emit('refresh-billboards')
                }
            }
            this.el.sceneEl.emit('update-rotation', { x: 0, y: 0, z: 0 })
            _reapplyHiddenSectors();
            this.trackPanelsPosition();

            // Force-update reposition handle after animation completes
            const mainSettingsEl = document.querySelector('[main-settings]');
            const mainSettings = mainSettingsEl?.components?.['main-settings'];
            if (mainSettings && mainSettings.moveCentralPanelArea && mainSettings.moveCentralPanelArea.getAttribute('visible')) {
                mainSettings._updateCentralHandlePosition();
            }
        }, this.animanitionSegmentTime + 50);

        const targetZ_central = destZ_central;
        const targetZ_left = this.isStepIncreased ? pCZ : pRZ;
        const targetZ_right = this.isStepIncreased ? pLZ : pCZ;

        const isNewsGraphActive = !!document.getElementById('news-graph-wrapper');
        if (targetZ_central > targetZ_left && targetZ_central > targetZ_right && !isNewsGraphActive) {
            dockPanel.setAttribute('visible', 'true');
            self.changeScale(dockPanel, 1.05, self.animanitionSegmentTime)
            animatePosition(dockPanel, 0, '-0.14 1.06 -1.75')
            dockPanel.emit('start_position_0')
            
            const switchEl = document.getElementById('switch-table-chart');
            if (switchEl && switchEl.components['switch-table-chart']) {
                switchEl.components['switch-table-chart'].setCenterState(true, self.animanitionSegmentTime);
            }
            centralPanels.forEach(p => {
                if (p.id === 'watchlist-table' && p.components['watchlist-table']) {
                    p.components['watchlist-table'].setCompactMode(false);
                }
            });
        } else {
            self.changeScale(dockPanel, 0.001, self.animanitionSegmentTime)
            animatePosition(dockPanel, 0, '-0.14 -1.06 -1.75')
            dockPanel.emit('start_position_0')
            
            const switchEl = document.getElementById('switch-table-chart');
            if (switchEl && switchEl.components['switch-table-chart']) {
                switchEl.components['switch-table-chart'].setCenterState(false, self.animanitionSegmentTime);
            }
            centralPanels.forEach(p => {
                if (p.id === 'watchlist-table' && p.components['watchlist-table']) {
                    p.components['watchlist-table'].setCompactMode(true);
                }
            });
        }

        function animatePosition(el, index, position, delay = 0) {
            const animName = `animation__position__${index}`;

            el.setAttribute(animName, {
                property: 'position',
                to: position,
                dur: self.animanitionSegmentTime,
                delay,
                easing: 'easeInOutQuad',
                startEvents: `start_position_${index}`
            });
        }
        function animateRotation(el, index, rotation, delay = 0) {
            el.setAttribute('animation__rotation', {
                property: 'rotation',
                to: rotation,
                dur: self.animanitionSegmentTime,
                delay,
                easing: 'easeInOutQuad',
                startEvents: `start_rotation_${index}`
            });
        }
    },

    changeScale: function (el, scale, time) {
        el.setAttribute('animation__scale', {
            property: 'scale',
            to: `${scale} ${scale} ${scale}`,
            dur: time,
            easing: 'easeInOutQuad',
        });
    },

    checkIfChartNotBlocked() {
        const configureControlElement = document.querySelector('#configure-control');
        const configureControlAttr = configureControlElement ? configureControlElement.getAttribute('configure-control') : null;

        return !!(configureControlAttr && configureControlAttr.position === 'Manual')
    },
})
